import { Avatar, Drawer, Modal, Radio, Upload } from 'antd'
import React, { useEffect, useRef, useState } from 'react'
import ButtonCustom from '../../../../../Components/ButtonCustom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faArrowUpFromBracket,
  faCity,
  faEnvelope,
  faFloppyDisk,
  faHouseUser,
  faIdCard,
  faLocationDot,
  faMobileButton,
  faPhone,
  faPlus,
  faUpload,
  faUser,
  faXmark,
} from '@fortawesome/free-solid-svg-icons'
import { NavegacaoDrawer } from '../../../../app/recomendacao/novoCompatibilidadeAtivo/components/gavetaCadastrar/styled'
import { HeaderDrawer } from '../../../../../Components/CustomUi/headerGaveta'
import { BodyDrawer } from '../../styles'
import ImgCrop from 'antd-img-crop'
import { UploadProps } from 'antd/lib'
import { UploadChangeParam } from 'antd/lib/upload'
import Svg, { PlusOutlined } from '@ant-design/icons'
import { regular } from '@fortawesome/fontawesome-svg-core/import.macro'
import Input from '../../../../../Components/CustomUi/input'
import { Select } from '../../../../../Components/CustomUi/Select'
import { cepMask, cpfMask, fixoMask, phoneMask } from '../../../../../services/Afins'
import { Render } from '../../../../../Components/CustomUi/render'
import Carregando from '../../../../../Components/CustomUi/loading'
import { Box } from '../../../../../Components/CustomUi/box'
import { maskCNPJ } from '../../../../../utils'

interface PropsForm {
  open: boolean
  fecharGaveta: Function
  update: number
  logo: any[]
  setLogo: React.Dispatch<React.SetStateAction<any[]>>
  nome: string
  setNome: React.Dispatch<React.SetStateAction<string>>
  cpf_cnpj: string
  setCpf_cnpj: React.Dispatch<React.SetStateAction<string>>
  email: string
  setEmail: React.Dispatch<React.SetStateAction<string>>
  celular: string
  setCelular: React.Dispatch<React.SetStateAction<string>>
  telefone: string
  setTelefone: React.Dispatch<React.SetStateAction<string>>
  cep: string
  setCep: React.Dispatch<React.SetStateAction<string>>
  dataCity: any[]
  dataUf: any[]
  cidade: string
  setCidade: React.Dispatch<React.SetStateAction<string>>
  setCidadeId: React.Dispatch<React.SetStateAction<number>>
  estado: string
  setEstado: React.Dispatch<React.SetStateAction<string>>
  setEstadoId: React.Dispatch<React.SetStateAction<number>>
  endereco: string
  setEndereco: React.Dispatch<React.SetStateAction<string>>
  complemento: string
  setComplemento: React.Dispatch<React.SetStateAction<string>>
    tipo_cliente: string
  setTipo_cliente: React.Dispatch<React.SetStateAction<string>>
  timeRenderizar: boolean
  setTimeRenderizar: React.Dispatch<React.SetStateAction<boolean>>
  salvarConsultoria: Function
  loading: boolean
  carregando: boolean
  logoUrl: string
  handleChangeCidadeUf: Function
}

export const FormConsultoria: React.FC<PropsForm> = ({
  open,
  fecharGaveta,
  update,
  logo,
  setLogo,
  nome,
  setNome,
  cpf_cnpj,
  setCpf_cnpj,
  email,
  setEmail,
  celular,
  setCelular,
  telefone,
  setTelefone,
  cep,
  setCep,
  dataCity,
  dataUf,
  cidade,
  setCidade,
  setCidadeId,
  estado,
  setEstado,
  setEstadoId,
  endereco,
  setEndereco,
  complemento,
  setComplemento,
  tipo_cliente,
  setTipo_cliente,
  timeRenderizar,
  setTimeRenderizar,
  salvarConsultoria,
  loading,
  carregando,
  logoUrl,
  handleChangeCidadeUf
}) => {
  const [openCidade, setOpenCidade] = useState<boolean>(false)
  const [openEstado, setOpenEstado] = useState<boolean>(false)

  const handleChange = ({ fileList }: any) => {
    setLogo(fileList)
  }

  function onRemove() {
    setLogo([])
  }

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setTimeRenderizar(true)
    }, 1000)

    return () => {
      clearTimeout(timeoutId)
      setTimeRenderizar(false)
      console.log('Timeout cancelado!')
    }
  }, [])

  return (
    <Drawer
      width={550}
      open={open}
      onClose={() => fecharGaveta()}
      closable={false}
      bodyStyle={{ padding: 0 }}
      headerStyle={{ padding: '10px 10px' }}
      destroyOnClose
      footer={
        <div className='footer'>
          <ButtonCustom
            icon={<FontAwesomeIcon icon={faFloppyDisk} />}
            type='primary'
            onClick={salvarConsultoria}
            disabled={loading}
            loading={loading}
          >
            Salvar
          </ButtonCustom>
        </div>
      }
      title={
        <NavegacaoDrawer>
          <ButtonCustom
            danger
            icon={<FontAwesomeIcon icon={faXmark} />}
            type='tertiary'
            onClick={() => {
              fecharGaveta()
              setTipo_cliente('')
            }}
            style={{ marginLeft: -10 }}
          >
            Fechar
          </ButtonCustom>
        </NavegacaoDrawer>
      }
    >
      <>
        <HeaderDrawer>
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            {update > 0 ? 'Atualizar consultoria' : 'Cadastrar consultoria'}

            {/* <small style={{ opacity: '0.5', fontSize: '9px' }}>{criadoPorAtualizadoPor}</small> */}
          </div>
        </HeaderDrawer>
        <Render condition={carregando === false}>
          <BodyDrawer>
            <Box style={{ gap: '5px' }}>
              <label>Tipo do cliente</label>
              <Radio.Group
                buttonStyle='outline'
                onChange={(e) => setTipo_cliente(e.target.value)}
                value={tipo_cliente}
              >
                <Radio name='tipo' value='F'>
                  Pessoa física
                </Radio>

                <Radio name='tipo' value='J'>
                  Pessoa jurídica
                </Radio>
              </Radio.Group>
            </Box>
            <div className='campo__dois__inputs__logo'>
              <div style={{ marginTop: '15px' }}>
                <Upload
                  listType='picture-card'
                  fileList={logo}
                  beforeUpload={() => false}
                  onChange={handleChange}
                  onRemove={onRemove}
                  accept='image/*'
                  maxCount={1}
                  showUploadList={{
                    showPreviewIcon: false, // tira o "olho"
                    showRemoveIcon: true, // mantém só excluir
                  }}
                >
                  {logo?.length >= 1 ? null : (
                    <div className='div__teste'>
                      <Avatar
                        draggable
                        src={logoUrl}
                        size='large'
                        shape='square'
                        style={{ backgroundColor: '#ffffff' }}
                        className='avatar__profile'
                      ></Avatar>
                      <FontAwesomeIcon icon={faUpload} className='upload__icone' />
                    </div>
                  )}
                </Upload>
              </div>
              <div style={{ width: '100%' }}>
                <Input
                  label='Nome'
                  placeholder='Digite o nome da consultoria'
                  value={nome}
                  onChange={setNome}
                  icon={faUser}
                />
                <Render condition={tipo_cliente === 'F' || tipo_cliente === ''}>
                  <Input
                    label='CPF'
                    placeholder='000.000.000.00'
                    value={cpfMask(cpf_cnpj)}
                    onChange={setCpf_cnpj}
                    icon={faIdCard}
                    maxLength={15}
                  />
                </Render>
                <Render condition={tipo_cliente === 'J'}>
                  <Input
                    label='CNPJ'
                    placeholder='00.000.000/0000-00'
                    value={maskCNPJ(cpf_cnpj)}
                    onChange={setCpf_cnpj}
                    icon={faIdCard}
                    maxLength={18}
                  />
                </Render>
              </div>
            </div>
            <Input
              label='Email'
              placeholder='Digite o email'
              value={email}
              onChange={setEmail}
              icon={faEnvelope}
            />

            <Input
              label='Celular'
              placeholder='(00) 00000-0000'
              value={phoneMask(celular)}
              onChange={setCelular}
              icon={faMobileButton}
            />
            <Input
              label='Telefone'
              placeholder='(00) 0000-0000'
              value={fixoMask(telefone)}
              onChange={setTelefone}
              icon={faPhone}
            />

            <Input
              label='CEP'
              placeholder='00000-000'
              value={cepMask(cep)}
              onChange={setCep}
              icon={faLocationDot}
            />

            <Select
              label='Estado'
              placeholder='Selecione o estado'
              icon={faCity}
              value={estado}
              onChange={setEstado}
              onChangeID={(e) => handleChangeCidadeUf(e)}
              open={openEstado}
              trigger={setOpenEstado}
              items={dataUf}
              descricaoItem={'nome'}
              idItem={'cod'}
            />
            <Select
              label='Cidade'
              placeholder='Selecione a cidade'
              icon={faCity}
              value={cidade}
              onChange={setCidade}
              onChangeID={setCidadeId}
              open={openCidade}
              trigger={setOpenCidade}
              items={dataCity}
              descricaoItem={'nome'}
              idItem={'cod'}
            />

            <Input
              label='Endereço'
              placeholder='Digite o endereço'
              value={endereco}
              onChange={setEndereco}
              icon={faHouseUser}
            />
            <Input
              label='Complemento'
              placeholder='Digite o complemento '
              value={complemento}
              onChange={setComplemento}
              icon={faPlus}
            />
          </BodyDrawer>
        </Render>
        <Render condition={carregando}>
          <Carregando animation legenda='Carregando...' justifyContent='center' height={600} />
        </Render>
      </>
    </Drawer>
  )
}
